// extracted by mini-css-extract-plugin
export default {"select":"AppearanceSelect_select__Kf2Pe","wrapper":"AppearanceSelect_wrapper__p1Ta-","label":"AppearanceSelect_label__CEEMy"};